import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';

export interface VolcesSubjectDetectionParams {
  /**
   * 待检测的图片URL地址
   */
  image_url: string;
}

export interface VolcesSubjectDetectionResource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
  [key: string]: any;
}

/**
 * volces_subject_detection
 *
 * API Documentation: https://www.volcengine.com/docs/85621/1829011
 * 
 * Volces 主体检测服务,用于检测图片中的主体并返回遮罩图URL。支持检测人物、宠物、动漫等多种主体类型。
 *
 * @example
 * ```typescript
 * import { initSeacloud, volcesSubjectDetection } from 'seacloud-sdk';
 *
 * initSeacloud('your-api-key');
 *
 * const result = await volcesSubjectDetection({
 *   // 参数见 VolcesSubjectDetectionParams 接口定义
 * });
 *
 * console.log(result); // 返回生成的资源列表
 * ```
 *
 * @param params 请求参数，详见 VolcesSubjectDetectionParams 接口定义
 * @returns 生成的资源列表
 */
export async function volcesSubjectDetection(
  params: VolcesSubjectDetectionParams,
): Promise<VolcesSubjectDetectionResource[]> {
  const client = await getClient();

  const pollingOptions = {
    intervalMs: 3000,
    maxAttempts: 60,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'volces_subject_detection',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: VolcesSubjectDetectionResource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          resources.push({
            type: resource.type || 'unknown',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
            ...resource,
          });
        }
      }
    }
  }

  return resources;
}
